/* eslint-disable func-names */
import throttle from 'lodash/throttle'
import * as dayjs from 'dayjs'
import { mapState } from 'vuex'
import socket from '../socket'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
const USER_IS_TYPING_MSG = 'uit'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
      showQaSession: (state) => state.showQaSession,
    }),
    slideType() {
      return this.slide.type
    },
    isSubmissionClosed() {
      return this.slide && this.slide.stopSubmission
    },

    // Need to place this method here, this allow the throttled function
    // to be cancelled by the setUserTypingEnd
    setUserTypingStart() {
      return throttle(function () {
        if (
          this.isSubmissionClosed ||
            (this.showQaSession && this.slideType !== 'question')
        ) return

        const payload = this._makePayload(true)

        socket.emit(USER_IS_TYPING_MSG, payload)
      }, 2000, { trailing: false })
    },
  },
  methods: {
    _makePayload(isTyping = true) {
      return [
        isTyping,
        this.slide.id,
        this.presentation.uniqueAccessCode,
        dayjs().utc().valueOf(),
        socket.getSocketId(),
      ]
    },
    setUserTypingEnd: throttle(function () {
      if (this.isSubmissionClosed) return

      this.setUserTypingStart.cancel()

      const payload = this._makePayload(false)

      socket.emit(USER_IS_TYPING_MSG, payload)
    }, 1000),
  },
}
